import styled from 'styled-components';
import { Link } from 'react-router-dom';
import MyJobQuoteWidgetComponent from './Barge.styled';
import rade_color from '../assets/rade-color.png';

const FooterStyle = styled.footer`
  display: flex;
  height: auto;
  margin-top: 100px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    height: auto;
    margin-top: 50px;
    flex-direction: column;
  }
  .row {
    background-color: rgba(219, 219, 219, 0.9);
    width: 100%;

    .main_footer {
      display: flex;
      margin-top: 50px;

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: column;
      }

      .section {
        width: 25%;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          width: 100%;
        }
        h3 {
          margin-bottom: 30px;
          color: rgb(11, 62, 144);
        }
      }
      .section.about_us {
        display: flex;
        gap: 20px;
        flex-direction: column;

        img {
          width: 200px;
        }

        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          margin-bottom: 40px;
          align-items: flex-start;
          justify-content: flex-start;
        }
        p {
          font-family: 'Open Sans', sans-serif;
          line-height: 2;
          font-size: 1.1rem;
          padding-right: 30px;
        }
        span {
          font-weight: 700;
        }
      }
      .section.services {
        margin-left: 10px;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          margin-bottom: 40px;
          margin-left: 0;
        }
        ul {
          padding: 0;
          list-style: none;
          li {
            &:hover {
              color: green;
            }
            i {
              margin-right: 15px;
              opacity: 0.5;
            }
            a {
              text-decoration: none;
              color: #000;
              opacity: 0.5;
              line-height: 2.2;
              &:hover {
                color: green;
              }
            }
          }
        }
      }
      .section.contact_info {
        margin-left: -35px;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          margin-bottom: 40px;
          margin-left: 0;
        }
        p {
          a {
            text-decoration: none;
            color: rgb(0, 0, 0);
            opacity: 0.5;
          }
        }
        .main_contact {
          ul {
            margin-top: 20px;
            list-style: none;
            padding: 0;
            li {
              line-height: 2;
              a {
                span:first-child {
                  color: #279e64;
                  margin-right: 10px;
                }
                font-size: 0.9rem;
                margin-right: 10px;
                text-decoration: none;
                color: rgba(0, 0, 0, 0.5);
              }
            }
          }
        }
      }
      .section.newsletter {
        p {
          opacity: 0.5;
          margin-bottom: 10px;
          line-height: 1.5;
        }
        div input[type='text'] {
          width: 100%;
          height: 40px;
          margin-top: 20px;
          margin-bottom: 20px;
          border: none;
          padding: 25px 15px;
        }
        div input[type='submit'] {
          font-family: 'Poppins', sans-serif;
          font-weight: bold;
          color: #fff;
          background-color: #279e64;
          width: 80%;
          height: 60px;
          border: none;
          border-radius: 30px;
        }
      }
    }
    .footer_bottom {
      display: flex;
      justify-content: center;
      gap: 20px;
      font-size: 0.8rem;
      margin-top: 20px;
      text-align: space-between;
      padding: 1rem;
      border-top: 1px solid rgba(0, 0, 0, 0.1);

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: column;
        text-align: center;
        gap: 10px;
      }

      p {
        color: rgba(0, 0, 0, 0.5);
      }
      a {
        text-decoration: none;
        color: rgba(0, 0, 0, 0.5);
        &:hover {
          color: green;
        }
      }
    }
  }
`;

const Footer = () => {
  return (
    <>
      <FooterStyle>
        <div className="row">
          <div className="container">
            <div className="main_footer">
              <div className="section about_us">
                <img src={rade_color} alt="" />
                <MyJobQuoteWidgetComponent></MyJobQuoteWidgetComponent>
              </div>
              <div className="section services">
                <h3>Best Services</h3>
                <ul>
                  <li>
                    <i class="fa-solid fa-angle-right"></i>
                    <a href="/commercial-cleaning">Commercial Cleaning</a>
                  </li>
                  <li>
                    <i class="fa-solid fa-angle-right"></i>
                    <a href="/residential-cleaning">Residential Cleaning</a>
                  </li>
                  <li>
                    <i class="fa-solid fa-angle-right"></i>
                    <a href="/services">Specialized Cleaning</a>
                  </li>
                  <li>
                    <i class="fa-solid fa-angle-right"></i>
                    <a href="/transport-and-logistics">Transport & Logistics</a>
                  </li>
                </ul>
              </div>
              <div className="section contact_info">
                <h3>Contact Info</h3>
                <div className="main_contact">
                  <ul>
                    <li>
                      <Link>
                        <span>
                          <i class="fa-solid fa-phone"></i>
                        </span>
                        <span>07405675285</span>
                      </Link>
                    </li>
                    <li>
                      <Link>
                        <span>
                          <i class="fa-solid fa-envelope"></i>
                        </span>
                        <span>info@radeintegratedservices.co.uk</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="section newsletter">
                <h3>Newsletter</h3>
                <p>
                  Subscribe for all news from us. Please enter your email to
                  form below.
                </p>
                <form action="">
                  <div>
                    <input
                      type="text"
                      placeholder="Enter your email"
                      name="email"
                    />
                  </div>
                  <div>
                    <input
                      name="button"
                      className="btn"
                      type="submit"
                      value="Subscribe Now"
                    />
                  </div>
                </form>
              </div>
            </div>
            <div
              className="footer_bottom"
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '20px',
                fontSize: '0.8rem',
                marginTop: '20px',
                textAlign: 'space-between',
                padding: '1rem',
                borderTop: '1px solid rgba(0, 0, 0, 0.1)',
              }}
            >
              <p>
                © {new Date().getFullYear()} RADE Integrated services Ltd. All
                rights reserved.
              </p>
              <a
                href="/privacy"
                style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.5)' }}
              >
                Privacy Policy
              </a>
              <a
                href="/terms"
                style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.5)' }}
              >
                Terms & Conditions
              </a>
            </div>
          </div>
        </div>
      </FooterStyle>
    </>
  );
};
export { Footer };
